import { initLazy } from '../utility/lazyload';
import 'intersection-observer';


const init = async () => {
    let options = {rootMargin: "0px 0px 1200px 0px"};
    const apiLink = `/api/news/filter`;
    const container = `js-news-container`;
    const loadMoreBtn = `js-news-loadmore`;
    const searchInput = `js-news-search`;
    const searchResult =`js-search-results`;
    const tags = `js-news__tag`;
    const loadTagsBtn = `js-loadmore-tags`;
    const apiExpectedReturnCount = 12;
    let loadingEntry = '';
    let loadingObserver = '';
    let tagsActiveCounter = 5;
    const activeSearcClass = `what-we-do__search-results--active`;
    let APIData = [];
    let args = {
        Category :  $(`#selectedcategory`).val(),
        Tag :  $(`#selectedTag`).val(),
        MonthYear :  $(`#selectedMonthYear`).val(),
        PageIndex :  0
    }

    const ajaxCall = (link, args, callType = 'POST') => {
        APIData = [];
        $.ajax({
            type: callType,
            data: JSON.stringify(args),
            url: link,
            processData: false,
            contentType: "application/json"
        }).done(data => {
            APIData = data.data
            renderTemplate(APIData);
            hideLoadMore(APIData);
            initLazy.init();
            $(`.${loadMoreBtn}`).removeClass('loading');
        });
    }

    const hideLoadMore = (APIData) => {
        if (APIData.length < apiExpectedReturnCount) {
            $(`.${loadMoreBtn}`).hide();
            $(`.loading-animation`).hide();
            if(loadingObserver != ''){
                loadingObserver.unobserve(loadingEntry);
            }
            
        }
    }

    const searchHandler = () => {
        let searchTimeout = 0;
        $(`.${searchInput}`).on('keyup change input', () => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                let keyword = $(`.${searchInput}`).val() ? $(`.${searchInput}`).val() : `""`;
                let APISearchLink = `/api/news/search?keyword=${keyword}`
                console.log(keyword != `""`)
                if(keyword != `""`){
                    $.get(APISearchLink, data => {
                        let APIData = data.data;
                        APIData.length > 0 ? searchResultHandler(APIData) : $(`.${searchResult}`).removeClass(activeSearcClass);
                        hideLoadMore(APIData);
                    });
                }else{
                    searchResultHandler([]);
                    $(`.${searchResult}`).removeClass(activeSearcClass);
                }
                

            }, 1000);
        })
    }

    const searchResultHandler = (data) =>{
        $(`.${searchResult}`).addClass(activeSearcClass)
        let contents = '';
            data.map( e => {
                contents = contents + searchResultTemplate(e.linkUrl.replace(`~`,``), e.linkName);
                $(`.${searchResult}`).html(`<ul>${contents}</ul>`);
            })
    }

    const loadTagsBtnhandler = () => $(`.${loadTagsBtn}`).on('click', () => tagsHandler());

    const tagsHandler = () => {
        const skipCount = 5;
        for(let i = tagsActiveCounter - skipCount; i < tagsActiveCounter; i++){
            $(`.${tags}`).eq(i).css('display','list-item')
        }
        tagsActiveCounter = tagsActiveCounter + skipCount;
    }

    const searchResultTemplate = (link,title) => {
        const template = `
            <li><a href="${link.replace('~','')}">${title}</a></li>
        `
        return template
    }

    const renderTemplate = (data) => {
        
        let template  = ``;
        if(data.length > 0){
            data.map((e, i) => {
                template = template + card(e.title, e.shortDescription, e.date, e.linkName, e.linkUrl.replace('~', ''), e.imageUrl)
            })
        }else{
            const NewsAwardsPath = `/about-us/news-and-awards`
            template = `
            <div style='width: 100%'>
                <div class="title">
                    <h2>No Results Found</h2>
                    <p>Sorry, We found no results with this filter combination</p>
                </div>
                <div class="cta-button">
                    <a href="${NewsAwardsPath}" class="btn btn-outline--primary"> Clear Filter</a>
                </div>
                
            </div>
            `
        }
        

        $(`.${container}`).html($(`.${container}`).html() + template);

    }

    const loadMoreHandler = (entry, observer) => {
            $(`.${loadMoreBtn}`).addClass('loading');
            args.PageIndex = args.PageIndex + 1;
            loadingEntry = entry;
            loadingObserver = observer;
            ajaxCall(apiLink,args);
    }

    const handleInfiniteScroll = (entries, observer) => {
        entries.forEach(entry => entry.isIntersecting ? loadMoreHandler(entry.target, observer) : null)
    }

    const infiniteScroll = () => {
        const observer = new IntersectionObserver(handleInfiniteScroll,options)
        $(`.${loadMoreBtn}`).each((i, el) => observer.observe($(`.${loadMoreBtn}`)[i]))
    }

    if ($('.js-news').length > 0) {
        setTimeout(() => { infiniteScroll(); }, 1000);
        ajaxCall(apiLink,args);
        searchHandler();
        loadTagsBtnhandler();
        tagsHandler();
    }

    const card = (title,desc,date,link,linkUrl,img) => {
        let Template = `
                <div class="news-cards">
                    <div class="card-img-header">
                        <a class="card-img-header__img js-lazy-bg" href="${linkUrl}" data-bg='${img}'">
                            <div class="ratio-spacer"></div>
                            <div class="js-lazy-bg__container"></div>
                        </a>
                        <div class="card-img-header__details card-img-header__details--fullheight">
                            <a href="${linkUrl}">
                                <h4 class="card-img-header__title">${title}</h4>
                            </a>
                            <small>${date}</small>
                            <div class="card-img-header__description">
                                <p>${desc}</p>
                            </div>
                            <a class="card-img-header__cta" href="${linkUrl}">
                                ${link}
                                <i class="ico-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            `;
        return Template;
        
    }
}

export const newsAPI = {
    init: init
};